export const ERROR_MESSAGES_LABELS = {
  multiple: 'ERROR_MESSAGES.IMPORT_DOCUMENT.Multiple_Errors',
  'row-argument-null': 'ERROR_MESSAGES.IMPORT_DOCUMENT.Row_Argument_Null',
  'document-to-update-not-found':
    'ERROR_MESSAGES.IMPORT_DOCUMENT.Document_To_Update_Not_Found',
  'file-exceeded-max-allowed-size': 'FileExceededMaxAllowedSize',
  'duplicate-key': 'ERROR_MESSAGES.IMPORT_DOCUMENT.DuplicateKey',
  'unsupported-kind': 'ERROR_MESSAGES.UnsupportedKind',
  'referenced-object': 'ERROR_MESSAGES.ReferencedObject',
  'delete-used-record': 'ERROR_MESSAGES.ValueIsUsedCannotDelete',
  'cannot-delete-last-item': 'ERROR_MESSAGES.CannotDeleteLastItem',
  'payment-order-is-paid': 'ERROR_MESSAGES.PAYMENTS.PaymentOrderIsPaid',
  'document-not-exist': 'ERROR_MESSAGES.DocumentNotExist',
  'document-is-locked': 'ERROR_MESSAGES.DocumentIsLocked',
  'document-is-blocked-by-limit': 'ERROR_MESSAGES.DocumentIsBlockedByLimit',
  'task-not-exist': 'ERROR_MESSAGES.TaskNotExist',
  'delete-document-in-approval': 'ERROR_MESSAGES.DeleteDocumentInApproval',
  'document-has-approval-path': 'ERROR_MESSAGES.DocumentHasApprovalPath',
  'nothing-to-approve': 'ERROR_MESSAGES.NothingToApprove',
  'nothing-to-reject': 'ERROR_MESSAGES.NothingToReject',
  'nothing-to-return': 'ERROR_MESSAGES.NothingToReturn',
  'nothing-to-return-back': 'ERROR_MESSAGES.NothingToReturnBack',
  'nothing-to-cancel': 'ERROR_MESSAGES.NothingToCancel',
  'request-not-exists': 'ERROR_MESSAGES.RequestNotExists',
  'document-already-exported': 'ERROR_MESSAGES.DocumentAlreadyExported',
  'kind-change-not-allowed': 'ERROR_MESSAGES.KindChangeNotAllowed',
  'approval-already-exists': 'ERROR_MESSAGES.ApprovalAlreadyExists',
  'file-already-exists': 'ERROR_MESSAGES.FileAlreadyExists',
  'file-is-locked': 'ERROR_MESSAGES.FileIsLocked',
  'file-in-approval': 'ERROR_MESSAGES.FileInApproval',
  'update-file-in-approval': 'ERROR_MESSAGES.UpdateFileInApproval',
  'folder-already-exists': 'ERROR_MESSAGES.FolderAlreadyExists',
  'paired-transaction-closed': 'ERROR_MESSAGES.CannotDeletePairedDocument',
  'feature-flag': 'ERROR_MESSAGES.ApplicationTierGeneralError',
  'expense-transaction-already-paired':
    'ERROR_MESSAGES.ExpenseTransactionAlreadyPaired',
  'document-already-paired-with-expense-transaction':
    'ERROR_MESSAGES.DocumentAlreadyPairedWithExpenseTransaction',
  'expense-transaction-already-unpaired':
    'ERROR_MESSAGES.TransactionDocumentPairNotFound',
  'user-has-connected-bank-account':
    'ERROR_MESSAGES.UserHasConnectedBankAccount',
  'clone-organization-timeout': 'ERROR_MESSAGES.CloneOrganizationTimeout',
  'bank-token-is-expired': 'EXPENSE_MANAGEMENT.INFO.ExpiredTitle',
  'property-contains-comma': 'ERROR_MESSAGES.PropertyContainsComma',
  'document-is-linked-with-budget': 'ERROR_MESSAGES.DocumentIsLinkedWithBudget',
  'peppol-document-validation-failed': 'PEPPOL.ERRORS.ValidationFailed',
  'invalid-peppol-id': 'PEPPOL.ERRORS.InvalidPeppolId',
  'peppol-connection-not-found': 'PEPPOL.ERRORS.OrganizationNoConnection',
  'peppol-participant-not-registered': 'PEPPOL.ERRORS.ParticipantNotRegistered',
  'document-already-sent-via-peppol': 'PEPPOL.ERRORS.AlreadySent',
};
